(function () {
  const TAB_BUTTON_CLASS =
    'appearance-none cursor-pointer rounded-full border-0 bg-transparent px-16 py-4 text-[16px] leading-24 font-normal whitespace-nowrap text-[#00000080] transition-colors duration-200 hover:text-[#000000F2] [&.active]:bg-[#0000000D] [&.active]:font-medium [&.active]:text-[#000000F2]';

  const CARD_DOT_GAP = 8;
  const CARD_ARROW_WIDTH = 7;
  const CARD_ARROW_INSET = 14;

  function clamp(value, min, max) {
    if (min > max) return (min + max) / 2;
    return Math.min(Math.max(value, min), max);
  }

  function positionCardNearDot(container, card, dot) {
    if (!container || !card || !dot) return;

    const containerRect = container.getBoundingClientRect();
    const clipEl =
      container.closest('.swiper-slide') || container.closest('.swiper') || container;
    const clipRect = clipEl.getBoundingClientRect();
    const dotRect = dot.getBoundingClientRect();
    const dotCenterX = dotRect.left + dotRect.width / 2 - containerRect.left;
    const dotCenterY = dotRect.top + dotRect.height / 2 - containerRect.top;
    const edgePadding = 8;

    card.style.display = 'flex';
    const cardWidth = card.offsetWidth || 130;
    const cardHeight = card.offsetHeight || 180;

    const minLeft = clipRect.left + edgePadding - containerRect.left;
    const maxLeft = clipRect.right - edgePadding - cardWidth - containerRect.left;
    const minTop = clipRect.top + edgePadding - containerRect.top;
    const maxTop = clipRect.bottom - edgePadding - cardHeight - containerRect.top;

    const leftOnRight =
      dotCenterX + dotRect.width / 2 + CARD_DOT_GAP + CARD_ARROW_WIDTH;
    const leftOnLeft =
      dotCenterX - dotRect.width / 2 - CARD_DOT_GAP - CARD_ARROW_WIDTH - cardWidth;
    const topOnAbove =
      dotCenterY - dotRect.height / 2 - CARD_DOT_GAP - CARD_ARROW_WIDTH - cardHeight;
    const topOnBelow =
      dotCenterY + dotRect.height / 2 + CARD_DOT_GAP + CARD_ARROW_WIDTH;

    const fitsClip = (left, top) => {
      const absLeft = containerRect.left + left;
      const absTop = containerRect.top + top;
      return (
        absLeft >= clipRect.left + edgePadding - 0.5 &&
        absLeft + cardWidth <= clipRect.right - edgePadding + 0.5 &&
        absTop >= clipRect.top + edgePadding - 0.5 &&
        absTop + cardHeight <= clipRect.bottom - edgePadding + 0.5
      );
    };

    const overlapsX = (left) => dotCenterX >= left && dotCenterX <= left + cardWidth;
    const overlapsY = (top) => dotCenterY >= top && dotCenterY <= top + cardHeight;

    const cardinals = [
      {
        place: 'right',
        left: leftOnRight,
        top: clamp(dotCenterY - cardHeight / 2, minTop, maxTop),
        axis: 'x',
      },
      {
        place: 'left',
        left: leftOnLeft,
        top: clamp(dotCenterY - cardHeight / 2, minTop, maxTop),
        axis: 'x',
      },
      {
        place: 'above',
        left: clamp(dotCenterX - cardWidth / 2, minLeft, maxLeft),
        top: topOnAbove,
        axis: 'y',
      },
      {
        place: 'below',
        left: clamp(dotCenterX - cardWidth / 2, minLeft, maxLeft),
        top: topOnBelow,
        axis: 'y',
      },
    ];

    let chosen = cardinals.find((candidate) => {
      if (!fitsClip(candidate.left, candidate.top)) return false;
      return candidate.axis === 'x'
        ? overlapsY(candidate.top)
        : overlapsX(candidate.left);
    });

    if (!chosen) {
      const diagonals = [
        { place: 'above-right', left: leftOnRight, top: topOnAbove },
        { place: 'above-left', left: leftOnLeft, top: topOnAbove },
        { place: 'below-right', left: leftOnRight, top: topOnBelow },
        { place: 'below-left', left: leftOnLeft, top: topOnBelow },
      ];
      chosen = diagonals.find((candidate) => fitsClip(candidate.left, candidate.top));
    }

    if (!chosen) {
      chosen = {
        place: 'right',
        left: clamp(leftOnRight, minLeft, maxLeft),
        top: clamp(dotCenterY - cardHeight / 2, minTop, maxTop),
      };
    }

    const alongX = clamp(
      dotCenterX - chosen.left,
      CARD_ARROW_INSET,
      Math.max(CARD_ARROW_INSET, cardWidth - CARD_ARROW_INSET)
    );
    const alongY = clamp(
      dotCenterY - chosen.top,
      CARD_ARROW_INSET,
      Math.max(CARD_ARROW_INSET, cardHeight - CARD_ARROW_INSET)
    );
    const along = chosen.place === 'left' || chosen.place === 'right' ? alongY : alongX;

    card.dataset.place = chosen.place;
    card.style.setProperty('--sa-inspo-arrow-along', `${along}px`);

    card.style.position = 'absolute';
    card.style.inset = 'auto';
    card.style.left = `${chosen.left}px`;
    card.style.top = `${chosen.top}px`;
    card.style.right = 'auto';
    card.style.bottom = 'auto';
    card.style.translate = '0';
    card.style.transform = 'none';
    card.style.zIndex = '20';
  }

  function restoreCard(card) {
    if (card._saHome && card.parentElement !== card._saHome) {
      card._saHome.appendChild(card);
    }

    card.removeAttribute('data-place');
    card.removeAttribute('data-place-left');
    card.removeAttribute('data-place-below');
    card.removeAttribute('data-place-above');
    card.style.removeProperty('--sa-inspo-arrow-along');
    card.style.position = '';
    card.style.inset = '';
    card.style.left = '';
    card.style.top = '';
    card.style.right = '';
    card.style.bottom = '';
    card.style.translate = '';
    card.style.transform = '';
    card.style.zIndex = '';
    card.style.visibility = '';
    card.style.display = '';
    card._saDot = null;
    card._saContainer = null;
  }

  function closeAllCards(root) {
    root.querySelectorAll('[data-sa-inspo-card]').forEach((card) => {
      card.classList.add('hidden');
      card.removeAttribute('data-open');
      card.setAttribute('aria-hidden', 'true');
      restoreCard(card);
    });

    root.querySelectorAll('[data-sa-inspo-dot]').forEach((dot) => {
      dot.setAttribute('aria-expanded', 'false');
    });
  }

  function openCard(root, dot, cardId) {
    closeAllCards(root);

    const card = root.querySelector(`[data-sa-inspo-card][data-card-id="${cardId}"]`);
    if (!card) return;

    if (!card._saHome) {
      card._saHome = card.closest('[data-sa-inspo-card-layer]') || card.parentElement;
    }

    card._saDot = dot;
    card._saContainer = dot.closest('[data-sa-inspo-card-layer]') || card._saHome || root;
    card._saContainer.appendChild(card);

    card.classList.remove('hidden');
    card.setAttribute('data-open', 'true');
    card.setAttribute('aria-hidden', 'false');
    dot.setAttribute('aria-expanded', 'true');

    positionCardNearDot(card._saContainer, card, dot);
  }

  function canUseHoverInteraction() {
    return window.matchMedia('(hover: hover) and (pointer: fine)').matches;
  }

  function initHotspotHover(root) {
    if (!canUseHoverInteraction()) return;

    let closeTimer = null;

    const cancelScheduledClose = () => {
      if (closeTimer) {
        clearTimeout(closeTimer);
        closeTimer = null;
      }
    };

    const scheduleClose = () => {
      cancelScheduledClose();
      closeTimer = window.setTimeout(() => {
        closeAllCards(root);
      }, 120);
    };

    root.querySelectorAll('[data-sa-inspo-dot]').forEach((dot) => {
      dot.addEventListener('mouseenter', () => {
        cancelScheduledClose();
        openCard(root, dot, dot.dataset.cardId);
      });
    });

    root.addEventListener('mouseover', (event) => {
      if (
        event.target.closest('[data-sa-inspo-dot]') ||
        event.target.closest('[data-sa-inspo-card]')
      ) {
        cancelScheduledClose();
      }
    });

    root.addEventListener('mouseout', (event) => {
      const fromDot = event.target.closest('[data-sa-inspo-dot]');
      const fromCard = event.target.closest('[data-sa-inspo-card]');
      if (!fromDot && !fromCard) return;

      const related = event.relatedTarget;
      if (related instanceof Node && root.contains(related)) {
        if (related.closest('[data-sa-inspo-dot]') || related.closest('[data-sa-inspo-card]')) {
          return;
        }
      }

      scheduleClose();
    });
  }

  function initSwiper(swiperEl) {
    if (!swiperEl || swiperEl.swiper) return;
    if (typeof window.Swiper === 'undefined') return;

    const panel = swiperEl.closest('[data-sa-tab-panel]');
    if (panel?.hidden) return;

    const autoplay = swiperEl.dataset.autoplay === 'true';
    const autoplayDelay = Number.parseInt(swiperEl.dataset.autoplayDelay, 10) || 5000;
    const showPagination = swiperEl.dataset.showPagination === 'true';
    const showArrows = swiperEl.dataset.showArrows === 'true';
    const slideCount = swiperEl.querySelectorAll('.swiper-slide').length;

    const config = {
      slidesPerView: 1,
      spaceBetween: 0,
      autoHeight: true,
      observer: true,
      observeParents: true,
      watchOverflow: true,
    };

    if (autoplay && slideCount > 1) {
      config.autoplay = { delay: autoplayDelay, disableOnInteraction: false };
    }

    if (showPagination && slideCount > 1) {
      config.pagination = {
        el: swiperEl.querySelector('.sa-inspo-swiper-pagination'),
        clickable: true,
      };
    }

    if (showArrows && slideCount > 1) {
      config.navigation = {
        nextEl: swiperEl.querySelector('.sa-inspo-swiper-next'),
        prevEl: swiperEl.querySelector('.sa-inspo-swiper-prev'),
      };
    }

    const swiper = new window.Swiper(swiperEl, config);
    swiperEl.dataset.swiperInitialized = 'true';

    swiper.on('slideChange', () => {
      const root = swiperEl.closest('[data-sa-inspirational]');
      if (root) closeAllCards(root);
    });

    return swiper;
  }

  function updateSwipersInPanel(panel) {
    if (!panel || panel.hidden) return;

    panel.querySelectorAll('[data-sa-inspo-swiper]').forEach((swiperEl) => {
      if (swiperEl.swiper) {
        swiperEl.swiper.update();
        if (swiperEl.dataset.autoplay === 'true') {
          swiperEl.swiper.autoplay?.start();
        } else {
          swiperEl.swiper.autoplay?.stop();
        }
      } else {
        initSwiper(swiperEl);
      }
    });
  }

  function initSwipersForRoot(root) {
    if (typeof window.Swiper === 'undefined') {
      window.setTimeout(() => initSwipersForRoot(root), 50);
      return;
    }

    root.querySelectorAll('[data-sa-inspo-swiper]').forEach((swiperEl) => {
      const panel = swiperEl.closest('[data-sa-tab-panel]');
      if (panel?.hidden) return;
      if (swiperEl.swiper) {
        swiperEl.swiper.update();
      } else {
        initSwiper(swiperEl);
      }
    });
  }

  function fontFamilyFor(name) {
    if (name === 'Prata' || name === 'Cormorant Garamond') {
      return `'${name}', serif`;
    }
    if (name === 'Tenor Sans') {
      return `'${name}', sans-serif`;
    }
    return `'Poppins', sans-serif`;
  }

  function createTabButton(title, index, isActive, tabUrl, titleFont) {
    const button = document.createElement('button');
    button.type = 'button';
    button.className = TAB_BUTTON_CLASS;
    button.style.fontFamily = fontFamilyFor(titleFont);
    button.setAttribute('role', 'tab');
    button.dataset.saTabHeader = '';
    button.dataset.saInspoTab = '';
    button.dataset.tab = String(index);
    if (tabUrl) button.dataset.tabUrl = tabUrl;
    button.textContent = title;

    if (isActive) {
      button.classList.add('active');
      button.setAttribute('aria-selected', 'true');
    } else {
      button.setAttribute('aria-selected', 'false');
    }

    return button;
  }

  function titledPanels(root) {
    return Array.from(root.querySelectorAll('[data-sa-tab-panel]')).filter((panel) =>
      panel.dataset.tabTitle?.trim()
    );
  }

  function buildTabNav(root) {
    const tablist = root.querySelector('[data-sa-inspo-tablist]');
    const panels = titledPanels(root);
    if (!tablist || !panels.length) return [];

    tablist.replaceChildren();

    const headers = [];

    panels.forEach((panel, index) => {
      const title = panel.dataset.tabTitle.trim();
      const tabUrl = panel.dataset.tabUrl?.trim() || '';
      const button = createTabButton(
        title,
        index,
        index === 0,
        tabUrl,
        panel.dataset.titleFont
      );
      tablist.appendChild(button);
      headers.push(button);
    });

    return headers;
  }

  function initInspirational(root) {
    if (root.dataset.saInspoInit === 'true') return;
    root.dataset.saInspoInit = 'true';

    const headers = buildTabNav(root);
    const panels = titledPanels(root);
    const viewMoreLinks = root.querySelectorAll('[data-sa-view-more]');
    const fallbackViewMoreUrl = viewMoreLinks[0]?.getAttribute('href') || '#';

    function updateViewMore(tabIndex) {
      if (!viewMoreLinks.length) return;

      const tabUrl = panels[tabIndex]?.dataset.tabUrl?.trim() || '';
      const href = tabUrl || fallbackViewMoreUrl;

      viewMoreLinks.forEach((viewMore) => {
        viewMore.href = href;
      });
    }

    function switchTab(tabIndex) {
      headers.forEach((header, index) => {
        const isActive = index === tabIndex;
        header.classList.toggle('active', isActive);
        header.setAttribute('aria-selected', isActive ? 'true' : 'false');
      });

      panels.forEach((panel, index) => {
        const isActive = index === tabIndex;
        panel.hidden = !isActive;
        panel.classList.toggle('hidden', !isActive);

        if (isActive) {
          updateSwipersInPanel(panel);
        } else {
          panel.querySelectorAll('[data-sa-inspo-swiper]').forEach((swiperEl) => {
            swiperEl.swiper?.autoplay?.stop();
          });
        }
      });

      closeAllCards(root);
      updateViewMore(tabIndex);
    }

    headers.forEach((header) => {
      header.addEventListener('click', () => {
        const tabIndex = Number.parseInt(header.dataset.tab, 10);
        if (Number.isNaN(tabIndex)) return;
        switchTab(tabIndex);
      });
    });

    root.addEventListener('click', (event) => {
      const dot = event.target.closest('[data-sa-inspo-dot]');
      if (dot && root.contains(dot)) {
        if (canUseHoverInteraction()) return;

        event.preventDefault();
        event.stopPropagation();
        const cardId = dot.dataset.cardId;
        const card = root.querySelector(`[data-sa-inspo-card][data-card-id="${cardId}"]`);
        const isOpen = card && card.dataset.open === 'true';

        if (isOpen) {
          closeAllCards(root);
        } else {
          openCard(root, dot, cardId);
        }
      }

      const closeBtn = event.target.closest('[data-sa-inspo-card-close]');
      if (closeBtn && root.contains(closeBtn)) {
        event.preventDefault();
        closeAllCards(root);
      }
    });

    initHotspotHover(root);

    document.addEventListener('click', (event) => {
      if (!root.contains(event.target)) {
        closeAllCards(root);
      }
    });

    if (panels.length) {
      const initialIndex = headers.findIndex((header) => header.classList.contains('active'));
      switchTab(initialIndex >= 0 ? initialIndex : 0);
    } else {
      const href = Array.from(root.querySelectorAll('.sa-inspo-tab-panel'))
        .map((panel) => panel.dataset.tabUrl?.trim() || '')
        .find(Boolean);

      if (href) {
        viewMoreLinks.forEach((viewMore) => {
          viewMore.href = href;
        });
      }
    }

    const repositionOpenCard = () => {
      const open = root.querySelector('[data-sa-inspo-card][data-open="true"]');
      if (!open) return;

      const dot =
        open._saDot ||
        root.querySelector(`[data-sa-inspo-dot][data-card-id="${open.dataset.cardId}"]`);

      if (dot) {
        const container = open._saContainer || dot.closest('[data-sa-inspo-card-layer]') || root;
        positionCardNearDot(container, open, dot);
      }
    };

    window.addEventListener('resize', repositionOpenCard);
    window.addEventListener('scroll', repositionOpenCard, true);

    initSwipersForRoot(root);
  }

  function initAll() {
    document.querySelectorAll('[data-sa-inspirational]').forEach(initInspirational);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', (event) => {
    const root = event.target.querySelector('[data-sa-inspirational]');
    if (root) {
      root.dataset.saInspoInit = 'false';
      initInspirational(root);
    }
  });
})();
